export default __webpack_public_path__ + "static/media/Pierre_Benson_Wild_Flower_35_x_70_cm.d9a0be90.jpg";